import React from 'react';
import Square from '../Square';
import './styles.scss';
import Icon from '../Icon';

const checkbox = props => {
	const {
		styles,
		children,
		checked,
		large,
		clicked,
		index,
		name,
		value
	} = props;

	return (
		<div className="Checkbox" style={styles}>
			<Square
				clicked={clicked}
				active={checked}
				large={large}
				name={name}
				value={value}
				index={index}
			>
				<Icon icon={'check'} />
			</Square>
			<label className="Checkbox-label">{children}</label>
		</div>
	);
};

export default checkbox;
